import { SIGNATURE_STATUS } from '@/constants';

export class SignatureEntity {
  constructor({
    id,
    name = '',
    fileName = '',
    divisionNumber = 'GLOBAL',
    status = SIGNATURE_STATUS.active,
    deactivatedDate = null,
    createdAt = null,
    updatedAt = null,
  }) {
    this.id = id;
    this.name = name;
    this.fileName = fileName;
    this.divisionNumber = divisionNumber;
    this.status = status;
    this.deactivatedDate = deactivatedDate;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}
